import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({
  user,
  promoteToMember,
  demoteMember,
  isInEditMode,
  turnOnEditMode,
  turnOffEditMode,
  submitting,
  triggerSubmit
}) => {
  const userIsMember = user && user.isMember;
  const userNotMember = user && !user.isMember;

  return (
    <div className="Buttons">
      {isInEditMode && (
        <div className="editModeOnButtons">
          <Button white className="cancel" onClick={turnOffEditMode}>
            Cancel
          </Button>
          <Button
            className="save"
            disabled={submitting}
            blue={!submitting}
            isLoading={submitting}
            onClick={triggerSubmit}>
            Save
          </Button>
        </div>
      )}
      {!isInEditMode && (
        <div className="editModeOffButtons">
          <Button white className="edit" onClick={turnOnEditMode}>
            Edit
          </Button>

          {userIsMember && (
            <Button
              red
              className="demote"
              onClick={() => demoteMember(user.memberId)}>
              Demote Member
            </Button>
          )}

          {userNotMember && (
            <Button
              blue
              className="promote"
              onClick={() => promoteToMember(user.id)}>
              Promote to Member
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default Buttons;
